export default __webpack_public_path__ + "static/media/07.ee7d5e93.mp3";